<template>
  <div class="bh-ui-toast">
      {{text}}
  </div>
</template>

<script>
export default {
    name: 'toast',
    // data() {
    //     return {
    //         text:'测试'
    //     }
    // }
}
</script>

<style lang="less" scoped>
    .bh-ui-toast{
        position: fixed;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 17px;
        font-size:15px;
        font-family:PingFang SC;
        font-weight:300;
        color:rgba(255,255,255,1);
        background:rgba(5,11,17,0.88);
        // opacity:0.88;
        border-radius:8px;
        z-index: 999;
    }
</style>